import DeviceDetailsPanel from 'components/DeviceDetailsPanel/DeviceDetailsPanel';
import SimDetailsPanel from 'components/SimDetailsPanel/SimDetailsPanel';
import type { OnSimsModified, OpenModalCallback } from 'types/common';

interface SimAndDevicesViewProps {
  hologramSimId?: HologramSimId;
  simDetailBaseUrl: string;
  handleModalOpen: OpenModalCallback;
  onSimsModified: OnSimsModified;
}

const SimAndDevicesView: React.FC<SimAndDevicesViewProps> = ({
  hologramSimId,
  simDetailBaseUrl,
  handleModalOpen,
  onSimsModified,
}) => (
  <>
    <SimDetailsPanel hologramSimId={hologramSimId} simDetailBaseUrl={simDetailBaseUrl} />
    <DeviceDetailsPanel
      hologramSimId={hologramSimId}
      handleModalOpen={handleModalOpen}
      onSimsModified={onSimsModified}
    />
  </>
);

export default SimAndDevicesView;
